<template>
  <div class="d-flex">
    <label
      v-if="title"
      class="sn-body-1"
      :style="`color: ${titleColor}`"
      :for="labelFor"
      v-html="title"
    />
    <span
      v-if="optional"
      class="sn-body-1 sn-text-primary-01 ml-1"
    >
      (Optional)
    </span>
  </div>
</template>

<script>
import { snPrimary } from '~/assets/css/snui/_snColorVariables.scss'
export default {
  name: 'SnLabel',
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    optional: {
      type: Boolean,
      default: false,
      required: false
    },
    titleColor: {
      type: String,
      default: snPrimary,
      required: false
    },
    labelFor: {
      type: String,
      default: '',
      required: false
    }
  }
}
</script>
